import { dmApi } from "../dmApi";
import { getAuthorizationHeader, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";

export const productApi = dmApi.injectEndpoints({
  endpoints: (build) => ({

    // ✅ Add Product (FormData)
    addProduct: build.mutation({
      query: (formData) => ({
        url: "/admin/add-product",
        method: "POST",
        body: formData,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['Product'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Product added');
      },
    }),

    // ✅ Get All Products (paginated)
    getAllProducts: build.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/admin/get-all-products?page=${page}&limit=${limit}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['Product'],
    }),

    // ✅ Get Product by ID
    getProductById: build.query({
      query: (productId) => ({
        url: `/admin/get-product-by-id?productId=${productId}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['Product'],
    }),

    // ✅ Update Product (FormData)
    updateProduct: build.mutation({
      query: ({ productId, formData }) => ({
        url: `/admin/update-product?productId=${productId}`,
        method: "PUT",
        body: formData,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['Product'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Product updated');
      },
    }),

    // ✅ Delete Product
    deleteProduct: build.mutation({
      query: (productId) => ({
        url: `/admin/delete-product?productId=${productId}`,
        method: "DELETE",
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['Product'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Product deleted');
      },
    }),

  }),
});

export const {
  useAddProductMutation,
  useGetAllProductsQuery,
  useGetProductByIdQuery,
  useUpdateProductMutation,
  useDeleteProductMutation,
} = productApi;
